import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("arth_token")}`,
});
